module.exports = __webpack_public_path__ + "media/images/shinagawa-lasik-logo@2x-e4d6b9e44892e36cc8ef9b816264a2c5.webp";